import EmptyGuideBox from "components/atoms/boxs/EmptyGuideBox/EmptyGuideBox";
import LinkCard from "components/molecules/cards/LinkCard/LinkCard";
import { useEffect, useRef, useState } from "react";

interface Props {
  url: string;
  year: number;
}

const LinkList = ({ url, year }: Props) => {
  const listRef = useRef<HTMLDivElement>(null);
  const [guideShow, setGuideShow] = useState<boolean>(false);
  useEffect(() => {
    setTimeout(() => {
      if (!listRef.current) return;
      if (listRef.current?.getBoundingClientRect().height < 10) {
        setGuideShow(true);
      }
    }, 2000);
  }, []);
  return (
    <div ref={listRef}>
      {guideShow ? (
        <EmptyGuideBox />
      ) : (
        new Array(10)
          .fill(1)
          .map((_, _id) => <LinkCard url={url} year={year - _id - 1} />)
      )}
    </div>
  );
};

export default LinkList;
